import FaucetForm from "./components/FaucetForm";
import LoyaltyPage from "./components/LoyaltyPage";

import axios, { config } from "./configure";
import "./App.css";

import { createContext, useState, SetStateAction, Dispatch } from "react";
type Context = {
  theme: string;
  toggleTheme: Dispatch<SetStateAction<Context>>;
};

const initialState: Context = {
  theme: "",
  toggleTheme: (): void => {
    throw new Error("toggleTheme function must be overridden");
  },
};

export const ThemeContext = createContext(initialState);
function App() {
  const [theme, setTheme] = useState("dark");
  const toggleTheme = () => {
    setTheme((curr) => (curr === "light" ? "dark" : "light"));
  };

  // Simple routing: /loyalty shows loyalty page, everything else shows faucet
  const isLoyaltyPage = window.location.pathname === "/loyalty";

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      <div className="app" id={theme}>
        {isLoyaltyPage ? (
          <LoyaltyPage />
        ) : (
          <FaucetForm axios={axios} config={config} />
        )}
      </div>
    </ThemeContext.Provider>
  );
}

export default App;
